import { type PropsWithChildren, type ReactNode } from 'react';

import { Link } from 'react-router';

import {
  Button as ShadcnButton,
  type Props as ButtonProps,
} from './../shadcn/button';
import Button from './Button';

type Props = PropsWithChildren<
  {
    generate: () => Promise<void>;
    link?: string;
    generateLabel: string | ReactNode;
  } & Omit<ButtonProps, 'onSubmit'>
>;

export default function GenerateLinkButton({
  generate,
  link,
  children,
  generateLabel,
  ...props
}: Props) {
  if (!link) {
    return (
      <Button onSubmit={generate} {...props}>
        {generateLabel}
      </Button>
    );
  }

  return (
    <ShadcnButton asChild {...props}>
      <Link to={link} target="_blank">
        {children}
      </Link>
    </ShadcnButton>
  );
}
